import CryptoES from 'crypto-es';

/**
 * 암호화, 복호화 유틸 클래스
 *
 * 사용법 참조 : https://stackblitz.com/edit/angular-crypto?file=src%2Fapp%2Fapp.component.ts
 * 온라인 테스트 : https://www.devglan.com/online-tools/aes-encryption-decryption
 */
export class Cryptor {

  public static get LOGIN_KEY(): string {
    return "dcc41c65a51fa3d3362ea6f6021ea4a834ec23f4379508d7a09174352317aae0";
  }

  public static get LOGIN_IV(): string {
    return "1b6af8db2720c1f570277b07ddc3f609";
  }

  /**
   * 전달받은 데이터를 암호화 후 반환
   * @param value
   * @param key
   */
  public static aesEncrypt(value: string, key: string, iv: string): string {

    var result = CryptoES.AES.encrypt(
      value,
      CryptoES.enc.Hex.parse(key), {
      iv: CryptoES.enc.Hex.parse(iv),
      padding: CryptoES.pad.Pkcs7,
      mode: CryptoES.mode.CBC
    });

    return CryptoES.enc.Base64.stringify(CryptoES.enc.Hex.parse(result.ciphertext.toString()));
  }

  /**
   * 전달받은 암호화 데이터를 복호화 후 반환.
   * @param value
   * @param key
   */
  public static aesDecrypt(value: string, key: string, iv: string): string {

    var b64 = CryptoES.enc.Base64.parse(value);
    var hText = CryptoES.enc.Hex.parse(b64.toString());

    var result = CryptoES.AES.decrypt(
      CryptoES.enc.Hex.stringify(hText),
      CryptoES.enc.Hex.parse(key),
      {
        format: CryptoES.format.Hex,
        iv: CryptoES.enc.Hex.parse(iv),
        mode: CryptoES.mode.CBC,
        padding: CryptoES.pad.Pkcs7,
      }
    );

    return result.toString(CryptoES.enc.Utf8);

  }

  /**
   * 전달받은 데이터를 SHA256 해쉬로 변환 후 반환
   * @param value
   */
  public static sha256(value): string {
    return CryptoES.SHA256(value).toString();
  }

  public static MD5(value): string {
    return CryptoES.MD5(value).toString();
  }

  public static wordArray(value): any {
    return CryptoES.lib.WordArray.create(value);
  }
}
